import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from './components/navbar/Navbar';
import Home from './pages/homePage/Home'
import Charger from './pages/chargerPage/Charger';
import Headphone from './pages/headphonePage/Headphone';
import Watche from './pages/watchesPage/Watche';
import Offer from './pages/offersPage/Offer'
import Smart from './pages/smartPage/Smart';
import Details from './pages/detailsPage/Details';
import Order from './pages/orderPage/Order';
import Footer from './components/footer/Footer';
import NotFound from './pages/not-found/NotFound';

const App = () => {
  return (
    <BrowserRouter basename='/techjanet'>
    <Navbar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/charger' element={<Charger />} />
        <Route path='/headPhone' element={<Headphone />} />
        <Route path='/watche' element={<Watche />} />
        <Route path='/offers' element={<Offer />} />
        <Route path='/smart' element={<Smart />} />
        <Route path='/details/:id' element={<Details />} />
        <Route path='/order/:id/:name' element={<Order />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
